angular.module('cvsApp').service('authenticateService', ['networkService', 'xdrService', 'configManager',
    'authenticateModel', 'cvsAppData', '$base64', function (NS, XS, CM, AM, CAD, $base64) {

        function authenticate() {
            this.authenticate = function (callBackSuccess, oAuthenticate) {
                //get url
                // var tokenId = CAD.getTokenId();
                // var tokenType = CAD.getTokenType();
                var apikey = CAD.getApiKey();
                var url = CM.getApiUrlWOQueryParams('AUTHENTICATE');
                // var url = 'https://dev3fast.cvsspecialty.com/api/specialty/loginService/authenticate/1.0';
                if (url === "URL_ERROR") {

                } else {

                    //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                    var request = {
                        url: url,
                        header: {
                            'Content-Type': 'application/xml',
                            'accept': 'application/xml'
                        },
                        data: requestBody(oAuthenticate),
                        onSuccess: callBackSuccess
                    }
                    cvsUtility.commonServiceCode(url, "authenticate", AM, request, callBackSuccess, NS);
                }

            }

            var requestBody = function (oAuthenticate) {

                var apikey = CAD.getApiKey();
                var x2js = new X2JS();
                var xmlReq =  x2js.json2xml_str({
                    "authenticateRequest": {
                        "header": {
                            "serviceContext": {
                                "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                                "lineOfBusiness": "Specialty",
                                "channelName": 'WEB'
                            },
                            "securityContext": {
                                "apiKey": apikey
                            }
                        },
                        "details": {
                            "username": oAuthenticate.username,
                            "password": "$$$$$",
                            "sessionStartTimestamp": oAuthenticate.sessionStartTimestamp,
                            "ipAddress": oAuthenticate.ipAddress

                        }
                    }
                });

                return xmlReq.replace('$$$$$', '<![CDATA['+oAuthenticate.password+']]>');
                //     {                        
                //                 "username": oauthenticate.questionID,
                //                 "password": $base64.encode(oauthenticate.answer),
                //                 "sessionStartTimestamp":
                //                 "ipAddress":                                                    

                // });

            }

        }

        return new authenticate();
    }]);